<template>
    <v-app>
        <v-main>
            <div class="main">
                <ManagerNav v-if="isLogin && getRole==='manager'" />
                <JudgeNav v-if="isLogin && getRole==='judge'" />
                <router-view class="page-view" />
            </div>
        </v-main>
        <Alert />
        <Loading />
    </v-app>
</template>

<script>
import Alert from '@/components/UI/Alert.vue';
import Loading from '@/components/UI/Loading.vue';
import { mapGetters } from 'vuex';
import ManagerNav from '@/components/ManagerNav.vue';
import JudgeNav from '@/components/JudgeNav.vue';
import setupAutoLogout from '@/boot/auto-logout';

export default {
    name: 'App',
    components: {
        ManagerNav,
        JudgeNav,
        Alert,
        Loading,
    },
    data() {
        return {
            cleanupAutoLogout: null,
        };
    },
    computed: {
        ...mapGetters('mAuth', ['isLogin', 'getRole']),
    },
    watch: {
        isLogin: {
            immediate: true,
            handler(newValue) {
                // Clean up existing auto-logout if any
                if (this.cleanupAutoLogout) {
                    this.cleanupAutoLogout();
                    this.cleanupAutoLogout = null;
                }

                // Set up auto-logout only when logged in
                if (newValue) {
                    console.log('Setting up auto-logout');
                    this.cleanupAutoLogout = setupAutoLogout(this.$router, this.$store);
                }
            },
        },
    },
    unmounted() {
        // Clean up auto-logout when component is unmounted
        if (this.cleanupAutoLogout) {
            this.cleanupAutoLogout();
        }
    },
};
</script>

<style lang="scss">
* {
    font-family: 'Noto Sans TC', sans-serif;
    box-sizing: border-box !important;
}

.main {
    display: flex;
}

.page-view {
    width: calc(100vw - 300px);
    padding: 30px 20px;
    height: 100vh;
    overflow: scroll;
}
</style>
